import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'link-pos-inscricao',
  templateUrl: './link-pos-inscricao.component.html',
  styleUrls: ['./link-pos-inscricao.component.scss'],
})
export class LinkPosInscricaoComponent implements OnInit {

  @Input() label: string;
  @Input() path: string;
  @Input() externo: boolean;
  @Input() form: any;

  constructor() { }

  ngOnInit() {
  }

  redirecionarInscricao() {
    const formRequest = document.createElement('form');
    formRequest.action = this.path;
    formRequest.method = 'POST';
    formRequest.style.cssText = 'display: none;';
    formRequest.target = '_black';

    const inputCodCurso = document.createElement('input');
    inputCodCurso.type = 'text';
    inputCodCurso.name = 'codCurso';
    inputCodCurso.value = this.form.codCurso;
    formRequest.appendChild(inputCodCurso);

    const inputCodCampus = document.createElement('input');
    inputCodCampus.type = 'text';
    inputCodCampus.name = 'codCampus';
    inputCodCampus.value = this.form.codCampus;
    formRequest.appendChild(inputCodCampus);

    const inputCodTurma = document.createElement('input');
    inputCodTurma.type = 'text';
    inputCodTurma.name = 'codTurma';
    inputCodTurma.value = this.form.codTurma;
    formRequest.appendChild(inputCodTurma);

    document.body.appendChild(formRequest);
    formRequest.submit();
  }

}
